import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bba",
  "use": "icon-bba-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bba\">\n<path d=\"M0.866699 12.1428H8.29518V27H0.866699V12.1428ZM19.4382 6.57172H26.8667V27H19.4382V6.57172ZM10.1524 1H17.581V27H10.1524V1Z\" fill=\"#E96035\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol